import axios from 'axios';
import Cookies from 'js-cookie';
import {Locale} from 'types';
import {handleRedirect} from 'utils/request/validator';

export enum ContentType {
    FORM_DATA = 'multipart/form-data',
    FORM_URLENCODED = 'application/x-www-form-urlencoded',
    JSON = 'application/json',
}

// A friendly re-export for use with the request helper
export interface ProgressEvent {
    bytes: number;
    loaded: number;
    progress?: number;
    total?: number;
}

type RequestProps = {
    contentType?: ContentType;
    formData?: FormData | Record<string, unknown>;
    locale?: Locale;
    method?: 'DELETE' | 'GET' | 'PATCH' | 'POST' | 'PUT';
    onUploadProgress?: (progressEvent: ProgressEvent) => void;
    responseType?: 'blob';
    url: string;
};

/**
 * Creates the request headers for the axios request
 */
export const requestHeaders = (data: {
    contentType?: ContentType;
    locale?: Locale;
}) => ({
    Accept: 'application/json',
    'Accept-Language': data.locale,
    'Active-Language': data.locale,
    'Content-Type': data.contentType,
    'X-CSRFToken': Cookies.get('csrftoken'),
    'X-MakeLeaps-Request-Source': 'UI',
    'X-MakeLeaps-Request-Tool': 'react',
});

/**
 * This request handler has the assumption that the developer doesn't need access to the 'meta' object that comes back from Hat's requests
 * Example {meta:{status:200}, response: {name:'John'}}
 * The request handler will only return the response object
 * Example returned object: {name:'John'}
 */
export const request = ({
    contentType,
    formData,
    locale,
    method,
    onUploadProgress,
    responseType,
    url,
}: RequestProps) => {
    return axios({
        data: formData,
        headers: requestHeaders({contentType, locale}),
        method,
        onUploadProgress,
        responseType,
        url,
    }).then((response) => {
        if (handleRedirect(response)) return;

        return response.data.response;
    });
};
